import React, {Component} from 'react';

import Background from "./img/sfondothesandbox.png"
import Titolo from "./img/titolosandbox.png"
import Logo from "./img/logo.png"

import Navbar from "./components/navbar";
import Carousel from "./components/sandboxcarousel";
import Story from "./components/story"

import { Stack, Center, Image, Box, Container, Text } from '@chakra-ui/react';


export default class Thesandbox extends Component {
  render() {
    return (
      <>
            <div className='container-fluid' style={{backgroundImage: "url(" + Background + ")", backgroundRepeat: "no-repeat", backgroundSize: "2750px", height: "1600px", weight: "1920px"}}>                
                <Navbar 
                img={Logo}
                color="#ffffff"/>
                <Center p={24}>
                  <Image src={Titolo} maxW='500px' width='500px' height="120px" />
                </Center>
                <Center>
                        <Stack direction={['column', 'row']} spacing='250px' h='350px'>
                            <Container w='100%' h='600px' bg='trasparent' centerContent>
                                <Box  bg='trasparent'  w='350px'  >
                                  <Carousel/>
                                </Box>
                            </Container>
                            <Container w='100%'h='500px' bg='trasparent' centerContent>
                                <Box  bg='trasparent'  w='350px' >
                                  <Text fontSize='25px' style={{fontFamily:"Roboto", color: "#ffffff"}} > Sotto il nostro punto di vista, il metaverso rappresenta la possibilità per la creazione di realtà italiane intese come “Little Italy”, cercando di creare un luogo accessibile a tutti gli amanti del folklore italico che vogliono vedere un’esperienza nel prodotto stesso. Il primo metaverso colonizzato sarà quello di The Sandbox: </Text>
                                  <Story/>
                                </Box>
                            </Container>
                        </Stack>
                  </Center>
            </div>       
      </>
    );
  }
}
